import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import {
  HEADER_KEY_CONTENT_TYPE,
  HEADER_VALUE_CONTENT_TYPE_APPLICATION_JSON,
} from '../../models';
import { HttpCallerService } from './http-caller.service';

const defaultHeaders = new HttpHeaders({
  [HEADER_KEY_CONTENT_TYPE]: HEADER_VALUE_CONTENT_TYPE_APPLICATION_JSON,
});

@Injectable({ providedIn: 'root' })
export class ServerCallerService extends HttpCallerService {
  private static serverDomain: string;

  public async init(serverDomain: string) {
    ServerCallerService.serverDomain = serverDomain;
  }

  public override get(
    path: string,
    headers?: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return super.get(
      this.generatePath(path),
      headers || defaultHeaders,
      responseType
    );
  }

  public override post(
    path: string,
    data: any,
    headers?: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return super.post(
      this.generatePath(path),
      data,
      headers || defaultHeaders,
      responseType
    );
  }

  public override put(
    path: string,
    data: any,
    headers?: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return super.put(
      this.generatePath(path),
      data,
      headers || defaultHeaders,
      responseType
    );
  }

  public override patch(
    path: string,
    data: any,
    headers?: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return super.patch(
      this.generatePath(path),
      data,
      headers || defaultHeaders,
      responseType
    );
  }

  public override delete(
    path: string,
    data?: any,
    headers?: HttpHeaders,
    responseType = HttpCallerService.RESPONSE_TYPE.JSON
  ): Promise<any> {
    return super.delete(
      this.generatePath(path),
      data,
      headers || defaultHeaders,
      responseType
    );
  }

  private generatePath(path: string): string {
    return `${ServerCallerService.serverDomain}${path}`;
  }
}
